<template>
    <v-dialog
      v-model="dialog"
      width="500">
      <v-card v-if="note">
         <v-card-title primary-title>
                <div>
                  <div class="headline">Raised by {{note.raisedByName}}</div>
                  <span class="headline">{{note.raisedAt | formatDate}}</span>
                  <div> <v-icon :color="alertLevelColor(note.alertLevel)">fiber_manual_record</v-icon> Category - {{note.categoryName}}</div>
                </div>
              </v-card-title>
          <v-card-text>
            <v-form v-model="valid">
            <v-container mt-0 pt-0>
                <v-layout column>
                    <v-flex>
                    </v-flex>
                    <v-flex>
                        {{note.details}}
                    </v-flex>
                    <v-flex>
                        <v-layout wrap>
                            <v-flex xs4 :key="index" v-for="(photo, index) in note.photos">
                                <a @click="viewImageNewTab(photo)">
                                <img class="actionNoteThumbnail" :src="formatPhotoURL(photo.photoName)" />
                                </a>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex>
                        <v-textarea label="Comments" v-model="comments" />
                    </v-flex>
                    <v-flex>
                        <v-switch
                            :label="isClosed ? 'Closed': 'Open'"
                            v-model="isClosed"
                        ></v-switch>
                    </v-flex>
                </v-layout>
            </v-container>
            </v-form>
          </v-card-text>
             <v-card-actions>
                <v-spacer></v-spacer>
                    <v-btn @click="save" color="primary" :disabled="!valid">Save</v-btn>
                    <v-btn @click="cancel" color="error">Cancel</v-btn>
                </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>

import ForecastingUtilService from '@/services/forecastingUtilService'
import moment from 'moment';

import { mapActions } from "vuex"

export default {
    components: {
 
    },
    props: {
        dialog: {
            type: Boolean,
            required: true
        },
        variety: {
            type: Object,
            required: true
        },
        note: {
            type: Object,
            required: true,
        }
    },
    data(){
        return {
            imageAuthToken: null,
            comments: "",
            isClosed: false,
            valid: false
        };
    },
    watch: {
        dialog(){
           if(this.dialog) {
               this.comments = this.note.comments;
               this.isClosed = this.note.isClosed;
           }
        },
    },
    computed: {

    },
    methods: {
        ...mapActions("ForecastingStore", [
            "saveNote",
            "updateData"
        ]),
        cancel() {
            this.$emit("cancel");
        },
        async save() {
            this.note.comments = this.comments;
            this.note.isClosed = this.isClosed;
            if(this.note.isClosed) {
                this.note.closedByName = this.$store.getters["UserStore/getFullName"];
                this.note.closedAt = moment().utc().format();
            } else {
                this.note.closedByName = "";
                this.note.closedAt = null;
            }

            await this.saveNote(this.note);
            await this.updateData();

            this.$emit("saveNote");
        },
        async loadImageAuthToken(){
            this.imageAuthToken = await this.$store.dispatch("UserStore/acquireImageAuthToken");
        },
        formatPhotoURL(photoName){
            if(this.imageAuthToken) {
                return process.env.VUE_APP_API_URI + '/forecasting/photoData?' + [
                    'PhotoName=' + photoName,
                    'Token=' + this.imageAuthToken
                ].join('&');
            }
        },
        viewImageNewTab(photo){
            window.open(this.formatPhotoURL(photo.photoName), '_blank');
        },
        alertLevelColor(alertLavel) {
            return ForecastingUtilService.getAlertLevelColor(alertLavel);
        },
    },
    async created(){
        await this.loadImageAuthToken();
    }
}
</script>

<style>

.actionNoteThumbnail {
    max-width: 100%;
}
</style>